import { RECEIVE_LICENSES } from '../constants/ActionTypes';

const licenses = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_LICENSES:
      return action.payload;
    default:
      return state;
  }
}

export default licenses;



// WEBPACK FOOTER //
// ./src/reducers/licenses.js